





































import mixins from 'vue-typed-mixins';
import { ReportStore, ReportNode } from '@/utils/ReportUtils';
import SurveyUtils, {
  Survey,
  SurveyState,
  SurveyParticipation,
} from '@/utils/SurveyUtils';
import cloneDeep from 'lodash.clonedeep';
import { LanguageObject } from '@/i18n';
import { SubOrganization } from '@/utils/SubOrganizationUtils';
import DashboardTileDisplayVue from '@/components/dashboard/DashboardTileDisplay.vue';

export default mixins().extend({
  components: {
    DashboardTileDisplay: DashboardTileDisplayVue,
  },

  props: {
    value: {
      type: Object as () => ReportNode<{
        survey: Survey;
        participation?: SurveyParticipation;
      }>,
    },
  },

  computed: {
    store() {
      return ReportStore;
    },

    states(): SurveyState[] | undefined {
      if (
        ReportStore.surveyParticipation?.submissionstate?.category ===
        'NOT STARTED'
      ) {
        return [];
      }

      const states =
        ReportStore.surveyParticipation?.submissionstate?.nextstate;
      if (this.$session?.role?.type === 'serviceprovider') {
        return states?.serviceprovider;
      } else if (this.$session?.role?.type === 'oversight') {
        return states?.oversight;
      } else {
        // admins can change to any nextstate
        return states?.serviceprovider?.concat(states?.oversight);
      }
    },

    dashboardContext(): any {
      return {
        survey: ReportStore.survey,
        surveyparticipation: ReportStore.surveyParticipation,
      };
    },
  },

  data(): {
    progress?: number;
    duedate?: string;
  } {
    return {
      progress: undefined,
      duedate: undefined,
    };
  },

  async mounted() {
    if (ReportStore.surveyParticipation && ReportStore.survey) {
      if (ReportStore.surveyParticipation.participationduedate) {
        this.duedate = ReportStore.surveyParticipation.participationduedate;
      } else {
        this.duedate = ReportStore.survey.duedate;
      }
      this.progress = await SurveyUtils.api.surveyParticipation.getProgress({
        surveyparticipationid: ReportStore.surveyParticipation?.id,
        surveyid: ReportStore?.survey?.id,
      });
    }
  },

  methods: {
    async download() {
      try {
        this.$alert.show('download', {
          type: 'info',
          messages: [this.$tc('page.survey.report.downloadInProgress')],
        });

        await SurveyUtils.downloadPDF({
          participationid: ReportStore.surveyParticipation?.id,
          id: ReportStore.survey?.id,
          language: this.$i18n.locale,
        });
      } catch (error) {
        this.$alert.show('download', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },

    async handleState(state: SurveyState) {
      let message: string;
      if (state.category === 'SUBMITTED') {
        message =
          this.$tc(
            'model.question.options.summary.state.validation',
            undefined,
            [this.$translate(state.name)]
          ) +
          ' ' +
          this.$tc(
            'model.question.options.summary.state.currentProgress',
            undefined,
            [this.progress]
          );
      } else {
        message = this.$tc(
          'model.question.options.summary.state.validation',
          undefined,
          [this.$translate(state.name)]
        );
      }

      await this.$confirm(message, async () => {
        if (ReportStore.surveyParticipation) {
          this.$alert.hide('state');
          const participation = cloneDeep(ReportStore.surveyParticipation);
          participation.submissionstate = state;

          const resp = await Promise.all([
            SurveyUtils.api.surveyParticipation.update(participation),
            SurveyUtils.api.surveyState.get(state.id as number),
          ]);

          participation.submissionstate = resp[1];
          ReportStore.surveyParticipation = participation;
        }
        this.$toast.push({
          type: 'success',
          text: this.$tc('model.question.options.summary.state.success'),
        });
      });
    },
  },
});
